import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import * as ApiActions from 'actions/api';
import HTMLText from 'components/HTMLText';
import Layout from 'components/Layout';
import '../styles/static.scss';
const mapStateToProps = createStructuredSelector({
    text: (state) => state.legal.tncUs,
});
class Privacy extends React.Component {
    static fetchData(_, store) {
        return store.dispatch(ApiActions.prefetchLegal('tncUs'));
    }
    render() {
        return (_jsxs(Layout, { children: [_jsx(Helmet, { meta: [{ name: 'event-id', content: 'tncUs' }] }), _jsx(Layout.Container, { children: _jsxs("div", { className: "static", children: [_jsx("h2", { children: "Terms&Conditions" }), _jsx(HTMLText, { component: "div", html: this.props.text && this.props.text.content })] }) })] }));
    }
}
export default connect(mapStateToProps)(Privacy);
